export const firebaseConfig = {
  apiKey: 'AIzaSyC3gbjyrquOqgOmQZAr-UlqvLurunc-nVM',
  authDomain: 'mxteampro.firebaseapp.com',
  databaseURL: 'https://mxteampro.firebaseio.com',
  projectId: 'mxteampro',
  storageBucket: 'mxteampro.appspot.com',
  messagingSenderId: '912248058834',
  appId: '1:912248058834:web:a65a5d33dd601be6644e0b',
  measurementId: 'G-9Q9NXX89LL'
};
